import { getAxiosObject } from '@/utils/library'
import {
  commonGetters,
  commonActions,
  commonMutations
} from '@/store/store_utils'
import { toCommonInstrumentCode } from '@/utils/measurement_utils'

const dataName = 'laboratoryDefaultValueSettings'

const state = {
  laboratoryDefaultValueSettings: [],
  updatedAt: '20101010101010'
}

const getters = {
  ...commonGetters(dataName, ['getData', 'getUpdatedAt'], { filterDel: true }),
  getLaboratoryDefaultValueSetting: state => masterLaboratoryInstrumentCode => {
    const commonInstrumentCode = toCommonInstrumentCode(
      masterLaboratoryInstrumentCode
    )
    return state.laboratoryDefaultValueSettings.find(
      setting => setting.masterLaboratoryInstrumentCode === commonInstrumentCode
    )
  }
}

const actions = {
  ...commonActions(['setData', 'setUpdatedAt', 'updateAfter']),
  async update(
    { commit },
    {
      laboratoryDefaultValueSetting,
      laboratoryItems,
      laboratoryReferenceRanges
    }
  ) {
    try {
      const axiosObject = getAxiosObject()
      const res = await axiosObject.put('/laboratory-default-value-settings', {
        laboratoryDefaultValueSetting,
        laboratoryItems,
        laboratoryReferenceRanges
      })
      if (res.status === 200) {
        commit('updateAfter', [res.data.laboratoryDefaultValueSetting])
        commit('laboratoryItems/updateAfter', res.data.laboratoryItems, {
          root: true
        })
        commit(
          'laboratoryReferenceRanges/updateAfter',
          res.data.laboratoryReferenceRanges,
          { root: true }
        )
        return 'success'
      }
    } catch (error) {
      return 'server error'
    }
  }
}

const mutations = {
  ...commonMutations(dataName, ['setData', 'setUpdatedAt', 'updateAfter'], {})
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
